import { render } from "./TDSettingCreate.vue?vue&type=template&id=4bd2ca83"
import script from "./TDSettingCreate.vue?vue&type=script&lang=js"
export * from "./TDSettingCreate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__